export default {
    route: {
        title: "商城",
        desc: "品质甄选 优质服务",
    },
    common: {
        category: "类别",
        subcategory: "子类",
        all: "全部",
        search: "请输入关键词",
        search_goods: "搜索商品",
        loading: "加载中···",
        no_more: "没有更多商品了～",
        add_cart_success: "加车成功",
        add_cart_fail: "加车失败",
    },
    more: {
        favorites: "收藏夹",
    },
    single: {
        all: "全部",
        price: "价格",
        deliver: "配送至",
        param: "参数",
        spec: "规格",
        color: "颜色",
        size: "尺寸",
        product: "产品",
        detail: "详情",
        evaluate: "评价",
        join_cart: "加入购物车",
        buy: "立即购买",
        style: "款式选择",
        select: "{num} 款可选",
        fav: "收藏",
        service: "客服",
        cart: "购物车",
        address: "选择配送地址",
        addr_add: "添加新地址",
    },
    cart: {
        title: "我的购物车",
        settlement: "结算",
        all: "全选",
        del_tip: "是否移除该商品？",
        total: "合计",
        edit: "修改",
        success_tip: "成功加入购物车，是否立即去购物车结算？",
        confirm: "去结算",
        cancel: "继续购物",
        select_tip: "请先选择产品",
        empty: "暂无商品",
    },
    fav: {
        title: "我的收藏夹",
        empty: "暂无收藏商品",
        del_tip: "是否移除该商品？",
        del_success: "删除收藏成功",
        del_fail: "删除收藏失败",
        no_more: "没有更多商品了～",
        add: "加入收藏",
        remove: "移出收藏",
        add_success: "添加成功",
        add_fail: "添加失败",
        del: "删除",
    },
};
